import { render } from "./Registro.vue?vue&type=template&id=c9d396a8&scoped=true&bindings={\"form\":\"data\",\"error\":\"data\",\"pathAccount\":\"data\",\"pathBriefcase\":\"data\",\"submit\":\"options\"}"
import script from "./Registro.vue?vue&type=script&lang=js"
export * from "./Registro.vue?vue&type=script&lang=js"

import "./Registro.vue?vue&type=style&index=0&id=c9d396a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c9d396a8"

export default script